import {formatMoney} from 'accounting';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import injectSheet from 'react-jss';

const styles = theme => {
    const costCol = {
        float: 'right',
        width: 80,
        textAlign: 'right',
        marginRight: 2
    };

    return {
        checkCol: {
            clear: 'both',
            float: 'left',
            width: 20
        },
        descCol: {
            float: 'left',
            width: 230
        },
        costCol: {
            ...costCol
        },
        costColNegative: {
            ...costCol,
            fontStyle: 'italic'
        }
    };
};

class Checkbox extends Component {
    static propTypes = {
        desc: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        retail: PropTypes.number.isRequired,
        handleCheckboxChange: PropTypes.func.isRequired
    };

    toggleCheckboxChange = () => {
        const {handleCheckboxChange, desc, code, retail} = this.props;
        handleCheckboxChange({desc, code, retail});
    };

    render() {
        const {desc, retail, checked, classes = {}} = this.props;
        const {checkCol, descCol, costCol, costColNegative} = classes;
        const isNegative = Math.sign(retail) === -1;
        const cost = formatMoney(retail);

        return (
            <div className="checkbox">
                <label>
                    <div className={checkCol}>
                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={this.toggleCheckboxChange}
                        />
                    </div>
                    <div className={descCol}>
                        {desc}
                    </div>
                    <div className={isNegative ? costColNegative : costCol}>
                        {cost}
                    </div>
                </label>
            </div>
        );
    }
}

export default injectSheet(styles)(Checkbox);
